<script setup>
import LifeTimeValueTable from '@frontJs/components/tables/projectManagement/sem/tenantReports/LifeTimeValueTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>LTV - SEM - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - SEM - LTV </PageTitle>

    <LifeTimeValueTable />
</template>
